export default {
  path: '/reset-password',
  name: 'reset-password',
  component: () => import(/* webpackChunkName: "reset-password" */ './ResetPassword')
}
